import $ from 'jquery';
import AOS from 'aos';
import 'jquery-ui/ui/widgets/accordion';
import Scrollbar from 'smooth-scrollbar';

$(document).ready(function(){
    $('.listing__sidebar').each(function (index, element) {
        $(element).css('max-height', window.innerHeight - 100);
    });


    $('.filtersAccordion').accordion({
        active: false,
        collapsible: true,
        heightStyle: "content",
        header: '.filtersAccordion__itemHeader',
        beforeActivate: function( event, ui ) {
            $(ui.oldHeader).parents('.filtersAccordion__item').removeClass('active');
            $(ui.newHeader).parents('.filtersAccordion__item').addClass('active');
        },
        activate: function( event, ui ) {
            if(!$.isEmptyObject(ui.newHeader.offset())) {
                //$('html:not(:animated), body:not(:animated)').animate({ scrollTop: ui.newHeader.offset().top - headerHeight }, 'normal');
            }

            if ( ui.newPanel.find('.scrollable').length ) {
                Scrollbar.init( ui.newPanel.find('.scrollable')[0], {
                    damping: 1,
                    continuousScrolling: false,
                    alwaysShowTracks: true
                } ).update();
            }

            Scrollbar.destroy( ui.oldPanel.find('.scrollable')[0] );
        }
    });


    $(document).on('click', '.buttonListingView', function () {
        const $listing = $('.listing');
        let state = $listing.hasClass('listingListView');
        $listing.toggleClass( 'listingListView', !state );
        Cookies.set('listing_format', state);
        AOS.refresh();
    });


    formManager.initForm('.filtersForm', {
        resetOnSuccess: false,
        ajaxSettings: {
            showLoader: true,
            url: location.href,
            onSuccess: function (response, args) {
                $("#listingContent").replaceWith( $(response).find('#listingContent') );
                $('html, body').animate({ scrollTop: $('#listing').offset().top - $('#mainNav').outerHeight() }, 200);
                return false;
            }
        }
    });

    /*$('.filtersForm').on('submit', function (e) {
        e.preventDefault();
        popupManager.loading();
        $.post({
            url: location.href,
            data: $(this).serialize(),
            success: function ( response ) {
                $("#listingContent").replaceWith( $(response).find('#listingContent') );
                $('html, body').animate({ scrollTop: $('#listing').offset().top - $('#mainNav').outerHeight() }, 200);
                popupManager.close();
            }
        });
    });*/

    var step = 1;
    let loading = false;
    let offset;
    const $listingTeasers = $('#listingTeasers');
    if ( $listingTeasers.length ) {
        $(window).on("load scroll.once", function() {
            if ( loading === true ) {
                return;
            }

            offset = $('#listingTeasers > *').length;
            if ( offset < parseInt($('#listingTeasers').data('total')) && $(window).scrollTop() + window.innerHeight > $listingTeasers.outerHeight() - 1000 ) {
                loading = true;
                $('#listingPagination').addClass('loading');
                ajaxManager.request({
                    url: location.href,
                    data: $('.filtersForm').serialize() + '&offset=' + offset,
                    onSuccess: function ( response ) {
                        $listingTeasers.append( $(response).find('#listingTeasers > *') );
                        $('#listingPagination').removeClass('loading');
                        loading = false;
                    },
                    dataType: 'html'
                });
            }
        });
    }


    $(document).on('click', '.listingFilters__header', function () {
        $(this).toggleClass('open');
        $('.listingFilters__content').slideToggle();
    });
});